export default __webpack_public_path__ + "static/media/calculatorIcon.c833ef9d.svg";